module.exports = __webpack_public_path__ + "static/img/role-pt.0282766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-1/role-pt.png
// module id = Uh9h
// module chunks = 1